module.exports = __webpack_public_path__ + "img/upload_video.c328373f.png";